export const LOCALSTORAGE_TOKEN_KEY = 'token';
export const LOCALSTORAGE_CACHE_KEY = 'axll-app-cache';
